import { render, staticRenderFns } from "./tabandheader.vue?vue&type=template&id=a2a5a21a&scoped=true&"
import script from "./tabandheader.vue?vue&type=script&lang=js&"
export * from "./tabandheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a5a21a",
  null
  
)

export default component.exports